import { Home } from 'lucide-react'
import type { Salon } from '../types'

interface Props {
  salon: Salon
  onChange: (salon: Salon) => void
}

const joursOptions = [4, 5, 6]

export default function SectionInfosSalon({ salon, onChange }: Props) {
  const set = <K extends keyof Salon>(key: K, value: Salon[K]) =>
    onChange({ ...salon, [key]: value })

  return (
    <section className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="flex items-center gap-2 px-5 py-4" style={{ background: '#EFF6FF' }}>
        <Home className="w-4 h-4" style={{ color: '#1A3C6E' }} />
        <h3 className="font-semibold text-sm" style={{ color: '#1A3C6E' }}>
          Informations salon
          <span className="ml-2 font-normal opacity-60">(optionnel)</span>
        </h3>
      </div>
      <div className="bg-white p-5 grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Nom du salon</label>
          <input
            type="text"
            value={salon.nom}
            onChange={(e) => set('nom', e.target.value)}
            placeholder="Mon Salon"
            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Ville</label>
          <input
            type="text"
            value={salon.ville}
            onChange={(e) => set('ville', e.target.value)}
            placeholder="Paris"
            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Nombre de postes</label>
          <input
            type="number"
            value={salon.nbPostes}
            onChange={(e) => set('nbPostes', parseInt(e.target.value) || 0)}
            min={1}
            max={20}
            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Jours d'ouverture/semaine</label>
          <select
            value={salon.joursOuverture}
            onChange={(e) => set('joursOuverture', parseInt(e.target.value))}
            className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 bg-white"
          >
            {joursOptions.map((j) => (
              <option key={j} value={j}>{j} jours</option>
            ))}
          </select>
        </div>
      </div>
    </section>
  )
}
